import { styled } from '@mui/material/styles'
import { themeColor, themeSpacing, Typography } from 'eezy-components'
import { css } from 'styled-components'

import _LockedIcon from 'ez-styles/assets/icons/lock.svg'

type StyleProps = {
  $isActive?: boolean
  $isChild?: boolean
  $locked?: boolean
}

export const MenuItemWrapper = styled('div')<StyleProps>`
  display: flex;
  flex-direction: row;
  align-items: center;

  svg {
    fill: ${(props: StyleProps) =>
      props.$isActive
        ? themeColor('primary', 'main')
        : themeColor('secondary', 'main')};
    width: ${themeSpacing(2.5)};
    height: ${themeSpacing(2.5)};
  }

  .arrow-icon {
    width: ${themeSpacing(1.5)};
    height: ${themeSpacing(1.5)};
  }

  &:hover {
    cursor: pointer;
    color: ${themeColor('primary', 'main')};
  }

  ${props =>
    props.$locked
      ? css`
          opacity: 0.7;
        `
      : ''}
`

export const StyledMenuItem = styled(Typography)<StyleProps>`
  color: ${(props: StyleProps) =>
    props.$isActive
      ? themeColor('primary', props.$isChild ? 'light' : 'main')
      : themeColor('secondary', props.$isChild ? 'light' : 'main')};
  display: block;
  padding: 1rem;
  cursor: ${(props: StyleProps) => (props.$isChild ? 'pointer' : 'inherit')};
  z-index: 9999;

  ${props =>
    props.$locked
      ? css`
          poiner-events: none;
          cursor: default;
        `
      : ''}
`

export const SubMenuWrapper = styled('div')`
  margin-left: ${themeSpacing(2.35)};
`

export const LockedIcon = styled(_LockedIcon)`
  fill: ${themeColor('secondary', 'main')};
  height: ${themeSpacing(1.75)} !important;
  width: ${themeSpacing(1.75)} !important;
  margin-right: ${themeSpacing(0.75)};
`
